/**
 * @author xyguo
 * @description 角色管理页面,展示所有角色信息
 * @Date 2020/1/2
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,component_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport} = component_tool;
class RoleList extends WizContainer {

  componentName = 'RoleList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '角色名称',
        field: 'name',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '角色编码',
        field: 'code',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '角色描述',
        field: 'remark',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }

    ]
    if (o['success']) {
      let data = o['data']
      WizBrowserExport({
        title: '角色信息',
        sheetName: '角色信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '角色信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        // getTypeNodeList: this._handleTypeNodeList
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD,
        export:this._handleFile
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(RoleList);
